import { Component } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { WarehouseStorageRate } from '../../models/warehouse-storage-rate.model';
import { WarehouseStorageRateService } from '../../services/warehouse-storage-rate.service';
import { WarehouseStorageRateValidatorService } from '../../validators/warehouse-storage-rate-validator.service';

@Component({
    selector: 'app-storage-rates-new',
    templateUrl: './storage-rates-new.component.html',
    styleUrls: ['./storage-rates-new.component.scss'],
    standalone: false
})
export class StorageRatesNewComponent {

  rate: WarehouseStorageRate = new WarehouseStorageRate();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private storageRateValidator: WarehouseStorageRateValidatorService,
    private storageRateService: WarehouseStorageRateService) { }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if (this.storageRateValidator.isValid(this.rate)) {
      this.storageRateService.createStorageRate(this.rate)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/warehousing/storage-rates';
      })
    } else {
      this.isError = true;
    }
  }
}
